import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { apiBaseURL } from '../system/Constants/API.js';

const initialState = {
  products: {
    productList: [],
    getStatus: 'pending'
  }
};


/**
 * Get all Active Products
 * Dispatch Function
 * @return {object} - success payload
 */
 export const getActiveProducts = createAsyncThunk(
  'products/GetActiveProducts',
  async thunkAPI => {
    try {
      const response = await axios.get(`${apiBaseURL}/api/v1/products/active`);
      return response.data.products;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

/**
 * Get all Products
 * Dispatch Function
 * @return {object} - success payload
 */
export const getProducts = createAsyncThunk(
  'products/GetProducts',
  async thunkAPI => {
    try {
      const response = await axios.get(`${apiBaseURL}/api/v1/products/`);
      return response.data.products;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

const slice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setProducts(state, action) {
      state.products.productList = action.payload;
    }
  },
  extraReducers: {
    [getProducts.pending]: (state, action) => {
      state.getStatus = 'loading';
    },
    [getProducts.fulfilled]: (state, action) => {
      state.products.productList = action.payload;
      state.getStatus = 'success';
    },
    [getProducts.rejected]: (state, action) => {
      state.getStatus = 'failed';
    },
    [getActiveProducts.pending]: (state, action) => {
      state.getStatus = 'loading';
    },
    [getActiveProducts.fulfilled]: (state, action) => {
      state.products.productList = action.payload;
      state.getStatus = 'success';
    },
    [getActiveProducts.rejected]: (state, action) => {
      state.getStatus = 'failed';
    }
  }
});

export const reducer = slice.reducer;

export const setProductsState = () => async dispatch => {
  let response = '';
  try {
    response = await axios.get(`${apiBaseURL}/api/v1/products/active`);
  } catch (err) {
    console.error(err);
  }
  dispatch(slice.actions.setProducts(response.data.products));
};
